<template>
  <div>
    <CircleChart :isPercentage="isPercentage" :score="score" :name="name">
      <template v-slot:default="slotProps">
        <text
          x="100"
          y="140"
          v-if="score"
          text-anchor="middle"
          transform="matrix(1 0 0 1 0 0)"
          >{{ slotProps.label }}
        </text>
      </template>
    </CircleChart>
    <small class="d-block reliability-rate text-center" v-if="reliabilityRate">
      {{ labels.reliabilityRate.title1 }}
      {{ labels.reliabilityRate.title2 }}:
      <span :class="reliabilityRate">
        {{ labels.reliabilityRate[reliabilityRate] || reliabilityRate }}
      </span>
    </small>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CircleChart from '@/components/Charts/CircleChart.vue'

export default {
  components: { CircleChart },

  props: {
    score: { type: Number, default: undefined },
    reliabilityRate: { type: String, default: undefined },
    name: { type: String, default: '' },
    isPercentage: { type: Boolean, default: false },
  },

  computed: {
    ...mapGetters({
      resources: 'resources',
    }),
    labels() {
      return this.resources.page.reports.engagement.metric
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/styles/custom/colors';

.reliability-rate {
  word-wrap: normal;

  .veryLow {
    color: map-get($theme-colors, 'red10');
  }
  .low {
    color: map-get($theme-colors, 'red09');
  }
  .medium {
    color: map-get($theme-colors, 'yellow02');
  }
  .high {
    color: map-get($theme-colors, 'green06');
  }
  .veryHigh {
    color: map-get($theme-colors, 'green05');
  }
}
</style>
